var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fb",
    transform: "translate(0.4179688 0.4176941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1694 36.3406C28.2041 36.3406 36.3388 28.2055 36.3388 18.1703C36.3388 8.13513 28.2041 0 18.1694 0C8.13472 0 0 8.13513 0 18.1703C0 28.2055 8.13472 36.3406 18.1694 36.3406Z",
    id: "Oval-3-Copy-12",
    fill: "#3B5A98",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60785 16.9559L2.60785 9.37208L0 9.37208L0 6.35845L2.60785 6.35845L2.60785 3.98396C2.60785 1.40416 4.22628 0 6.58933 0C7.72156 0 8.69397 0.0827923 8.97618 0.119221L8.97618 2.81494L7.33735 2.81494C6.05212 2.81494 5.80392 3.41104 5.80392 4.28202L5.80392 6.35845L8.70417 6.35845L8.30637 9.37208L5.80392 9.37208L5.80392 16.9559",
    transform: "translate(13.22754 9.238129)",
    id: "Shape",
    fill: "#FFFFFF",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbColor);
export default __webpack_public_path__ + "static/media/Fb_color.a6088378ed6667c59baaedc92b6d426d.svg";
export { ForwardRef as ReactComponent };